import { DatesHelpers } from "@core/helpers";

export const ICandidateTimeline = Object.freeze({
  date: "date",
  status: "status",
  label: "label",
});

export class TimelineOptionModel {
  constructor(data = {}) {
    this[ICandidateTimeline.date] = data[ICandidateTimeline.date];
    this[ICandidateTimeline.status] = data[ICandidateTimeline.status];
    this[ICandidateTimeline.label] = data[ICandidateTimeline.label];
  }

  getDate() {
    return this[ICandidateTimeline.date];
  }

  getDisplayDate() {
    const date = this.getDate() ? DatesHelpers.getDayjs(this.getDate()) : null;
    return date ? date.format("dddd DD MMM") : "";
  }

  getStatus() {
    return this[ICandidateTimeline.status];
  }

  getLabel() {
    return this[ICandidateTimeline.label];
  }
}
